// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".B1J42ystyDY9tB_ljkKb{height:100%;-webkit-box-orient:vertical;-ms-flex-direction:column;flex-direction:column;position:relative;z-index:0}.B1J42ystyDY9tB_ljkKb,.L_9jptrDMkCjsaIDoWX0{overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-direction:normal}.L_9jptrDMkCjsaIDoWX0{height:auto;min-height:0;-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-box-orient:horizontal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"appContainer": "B1J42ystyDY9tB_ljkKb",
	"main": "L_9jptrDMkCjsaIDoWX0"
};
module.exports = ___CSS_LOADER_EXPORT___;
